import { Injectable } from "@angular/core";

type ProviderKey = Symbol | string;

type ProviderSkipFunction<T = any> = (arg0: T) => boolean;

type ProviderAsyncFactory<T = any, K = any> = (arg0: K) => Promise<T>;

type ProviderEntry = {
  skip: ProviderSkipFunction;
  provide: ProviderAsyncFactory;
  priority: ProviderPriority;
};

export enum ProviderPriority {
  BASE = 0,
  INTEGRATION = 1
}

@Injectable()
export class ProviderService {
  private readonly map = new Map<ProviderKey, ProviderEntry[]>();

  set<T = any, K = any>({
    key,
    skip,
    provide,
    priority
  }: {
    key: ProviderKey;
    skip: ProviderSkipFunction<K>;
    provide: ProviderAsyncFactory<T, K>;
    priority: ProviderPriority;
  }): void {
    if (!this.map.has(key)) {
      this.map.set(key, []);
    }

    const list = this.map.get(key)!;

    list.push({
      skip,
      provide,
      priority
    });

    list.sort((left, right) => right.priority - left.priority);
  }

  get<T = any, K = any>(
    key: ProviderKey,
    arg0?: K
  ): ProviderAsyncFactory<T, K> {
    return this.map.get(key)!.find((x) => !x.skip(arg0))!.provide;
  }
}
